import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            // {
            //   path: '/software',
            //   redirect: '/software/smartTown'
            // },
            // {
            //   path: '/software/smartTown',
            //   name: 'software',
            //   component: resolve => require(['@/view/Software_smartTown'], resolve),
            //   meta: {
            //     title: '软件产品丨智能小镇管理系统'
            //   }
            // },
            // {
            //   path: '/software/bigData',
            //   name: 'software',
            //   component: resolve => require(['@/view/Software_bigData'], resolve),
            //   meta: {
            //     title: '软件产品丨大数据管理系统'
            //   }
            // }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
        path:'/software',
        name:'software',
        component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '瓦斯综合利用和咨询'
          }
        },
        {
          path:'/bigdata',
          name:'bigdata',
          component: resolve => require(['@/view/Bigdata'], resolve),
            meta: {
              title: '智慧管理平台'
            }
          },
          {
            path:'/energy',
          name:'energy',
          component: resolve => require(['@/view/Energy'], resolve),
            meta: {
              title: '节能减碳改造'
            }
          },
          {
            path:'/mine',
          name:'mine',
          component: resolve => require(['@/view/Mine'], resolve),
            meta: {
              title: '智慧矿山'
            }
          },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, 
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, 
        {
          path: '/companyhonors',
          name: 'companyhonors',
          component: resolve => require(['@/view/CompanyHonors'], resolve),
          meta: {
            title: '资质荣誉'
          }
        }, 
        {
          path: '/devHistory',
          name: 'devHistory',
          component: resolve => require(['@/view/DevHistory'], resolve),
          meta: {
            title: '发展历程'
          }
        }, 
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/news',
          name: 'news',
          component: resolve => require(['@/view/News'],resolve),
          meta: {
            title: '新闻动态'
          }
        },
        {
          path: '/case',
          name: 'case',
          component: resolve => require(['@/view/Case'],resolve),
          meta: {
            title: '客户案例'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js